class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    container.insertAdjacentHTML('beforeend', products.innerHTML);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);

const starFilter = document.getElementById('star-filter');

if (starFilter) {
  starFilter.addEventListener('change', function (event) {
    const selectedRating = parseInt(event.target.value);

    // Update the URL without reloading the page
    const url = new URL(window.location.href);
    if (selectedRating) {
      url.searchParams.set('rating', selectedRating);
    } else {
      url.searchParams.delete('rating');
    }
    window.history.pushState({}, '', url);

    // Apply the filter
    applyRatingFilter(selectedRating);
  });
}

// Apply filter on page load if "rating" param is in URL
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const rating = urlParams.get('rating');

  if (rating) {
    document.getElementById('star-filter').value = rating;
    waitForStarsAndApply(rating);
  }
});

// Core filtering logic
function applyRatingFilter(selectedRating) {
  const products = document.querySelectorAll('.grid__item');

  products.forEach(product => {
    const groupStars = product.querySelector('.group-stars');
    let starCount = 0;

    if (groupStars) {
      // Only count if stars have rendered
      const starsRendered = groupStars.querySelectorAll('.on, .on.half');
      starCount = starsRendered.length;
    }

    const shouldShow = !selectedRating || starCount === selectedRating;
    product.classList.toggle('product--hidden', !shouldShow);
  });
}

// Retry logic to ensure stars are injected before filtering
function waitForStarsAndApply(rating, retries = 15) {
  const products = document.querySelectorAll('.grid__item');

  // Check if at least one product has fully rendered stars
  const anyStarsRendered = Array.from(products).some(product => {
    const groupStars = product.querySelector('.group-stars');
    return groupStars && groupStars.querySelectorAll('.on, .on.half').length > 0;
  });

  if (anyStarsRendered || retries <= 0) {
    applyRatingFilter(parseInt(rating));
  } else {
    setTimeout(() => waitForStarsAndApply(rating, retries - 1), 300);
  }

}


